import { render, staticRenderFns } from "./MakingSerumVideoSection.vue?vue&type=template&id=393228dd&scoped=true&"
import script from "./MakingSerumVideoSection.vue?vue&type=script&lang=js&"
export * from "./MakingSerumVideoSection.vue?vue&type=script&lang=js&"
import style0 from "./MakingSerumVideoSection.vue?vue&type=style&index=0&id=393228dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393228dd",
  null
  
)

export default component.exports